<template>
  <div class="lithiumBatteryMES-page">
    <!-- 锂电池MES系统 -->
    <div class="haeder-container blackStatic">
      <Header></Header>
      <Nav></Nav>
    </div>
    <div class="caseDetails-banner-container">
      <div class="case-info-container">
        <p class="case-title">锂电池MES系统</p>
        <p class="case-describe">基于百倍云全面云端能力与硬件技术能力，打通设备终端到云平台，全面赋能工业行业，打造万物互联新时代</p>
        <!-- <a href="javascript:;" class="case-see-more-btn">点击咨询</a> -->
      </div>
    </div>
    <div class="caseDetails-all-content-container">
      <div class="case-introduce-item-container programme">
        <div class="caseDetails-center-content-container">
          <p class="introduce-item-title">混合云架构</p>
          <p class="introduce-item-describe"></p>
          <div class="introduce-content-container">
            <img src="../../assets/img/caseDetails/lithiumBatteryMES/default_img1.png" alt="" class="interface-img">
          </div>
        </div>
      </div>
      <div class="case-introduce-item-container interface">
        <!-- 全屏背景 -->
        <div class="fullScreen-bg">

        </div>
        <div class="caseDetails-center-content-container">
          <p class="introduce-item-title whiteText">平台介绍</p>
          <p class="introduce-item-describe whiteText">局域网本地操作+云端+手持设备</p>
          <div class="introduce-content-container">
            <img src="../../assets/img/caseDetails/lithiumBatteryMES/default_img5.png" alt="" class="interface-img">
          </div>
        </div>
      </div>
    </div>
    <Foot></Foot>
  </div>
</template>
<script>
import Header from '@/components/Header'
import Nav from '@/components/Nav'
import Foot from '@/components/Foot'

export default {
  name: 'lithiumBatteryMES',
  components:{
    Header,
    Nav,
    Foot
  },
}
</script>
<style lang="scss">
  
</style>